import { Grid } from "@mui/material";
import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import {Accordion, AccordionDetails } from "@mui/material";
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import { Popover } from '@mui/material';
import Logos from '../images/Logos.png';
import Paralela from "../components/Paralela";
import BotaoDec from '../components/BotaoDec'
import BotaoValores from "../components/BotaoValores";
import Principal from "../components/Principal";
import Footer from "../components/Footer";
import BotaoCertidoes from "../components/BotaoCertidoes";
import BotaoOrientacoes from "../components/BotaoOrientacoes";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';


const drawerWidth = 240;

const navItems = [
    { route: '/programacao', text: 'Programação' },
    { route: '/galeria', text: 'Galeria' },
    { popover: true, text: 'Dúvidas' },
    { route: 'https://credmarcha.cnm.org.br/', text: 'Certificados XXV Marcha' },
];

export default function Programacao(props) {
    const { window } = props;
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const [popoverAnchor, setPopoverAnchor] = React.useState(null);

    const handleDrawerToggle = () => {
        setMobileOpen((prevState) => !prevState);
    };

    const handlePopoverOpen = (event) => {
        setPopoverAnchor(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setPopoverAnchor(null);
    };

    // const drawer = (
    //     <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
    //         <List>
    //             {navItems.map((item) => (
    //                 <ListItem key={item.text} disablePadding>
    //                     <ListItemButton sx={{ textAlign: 'center' }}>
    //                         <Link to={item.route} style={{ textDecoration: 'none', color: 'inherit' }}>
    //                             <ListItemText primary={item.text} />
    //                         </Link>
    //                     </ListItemButton>
    //                 </ListItem>
    //             ))}
    //         </List>
    //     </Box>
    // );

    const container = window !== undefined ? () => window().document.body : undefined;

    return (
        <Grid sx={{ height: '100vh' }}>
            <Box sx={{ display: 'flex' }}>
                <CssBaseline />
                <AppBar
                    component="nav"
                    sx={{
                        backgroundColor: '#002758',
                        borderBottom: 0,
                        boxShadow: 'none',
                        position: 'static'
                    }}
                >
                    <Toolbar
                        sx={{
                            // display: 'flex',
                            // justifyContent: 'center',
                            // alignItems: 'center',
                            height: '18vh',
                            margin: '0 5% 0 5%',
                        }}
                    >
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            edge="start"
                            onClick={handleDrawerToggle}
                            sx={{ mr: 2, display: { sm: 'none' } }}
                        >
                            <MenuIcon /> MENU
                        </IconButton>

                        <Box sx={{ display: { xs: 'inline', sm: 'none' }, marginRight: 'auto' }}>
                            <Link to="/">
                                <img src={Logos} alt="Logos CNM e XXVI Marcha" style={{ width: '200px' }} />
                            </Link>
                        </Box>
                        <Grid sx={{ flexGrow: 1, display: { xs: 'none', sm: 'inline' } }}>
                            <Link to="/">
                                <img src={Logos} alt="Logos CNM e XXVI Marcha" style={{ width: '50%' }} />
                            </Link>
                        </Grid>

                        <Box sx={{ display: { xs: 'none', md: 'inline', sm: 'inline' } }}>
                            {navItems.map((item, index) => {
                                if (!item.popover) {
                                    return (
                                        <Button
                                            key={item.text}
                                            sx={{
                                                color: '#fff',
                                                fontSize: { xl: '1rem', lg: '0.8rem' },
                                                textTransform: 'none',
                                                ...(index === navItems.length - 1 && {
                                                    backgroundColor: '#FFBE00',
                                                    color: 'success.contrastText',
                                                    borderRadius: '11px',
                                                    paddingX: '15px',
                                                }),
                                            }}
                                            component={Link}
                                            to={item.route}
                                            target={index === navItems.length - 1 ? '_blank' : undefined}
                                            rel={index === navItems.length - 1 ? 'noopener noreferrer' : undefined}
                                        >
                                            {item.text}
                                        </Button>
                                    );
                                } else {
                                    return (
                                        <React.Fragment key={item.text}>
                                            <Popover
                                                id="duvidas-popover"
                                                open={Boolean(popoverAnchor)}
                                                anchorEl={popoverAnchor}
                                                onClose={handlePopoverClose}
                                                anchorOrigin={{
                                                    vertical: 'bottom',
                                                    horizontal: 'left',
                                                }}
                                                transformOrigin={{
                                                    vertical: 'top',
                                                    horizontal: 'left',
                                                }}
                                            >
                                                <List>
                                                    <ListItem disablePadding>
                                                        <BotaoDec />
                                                    </ListItem>
                                                    <ListItem disablePadding>
                                                        <BotaoValores />
                                                    </ListItem>
                                                    <ListItem disablePadding>
                                                        <BotaoCertidoes />
                                                    </ListItem>
                                                    <ListItem disablePadding>
                                                        <BotaoOrientacoes />
                                                    </ListItem>
                                                </List>
                                            </Popover>
                                            <Button
                                                aria-describedby={popoverAnchor ? 'duvidas-popover' : undefined}
                                                onClick={handlePopoverOpen}
                                                sx={{
                                                    color: '#fff',
                                                    fontSize: { xl: '1rem', lg: '0.8rem' },
                                                    textTransform: 'none',
                                                    ...(index === navItems.length - 1 && {
                                                        backgroundColor: '#FFBE00',
                                                        color: 'success.contrastText',
                                                        borderRadius: '11px',
                                                        paddingX: '15px',
                                                    }),
                                                }}
                                            >
                                                {item.text}
                                            </Button>
                                        </React.Fragment>
                                    );
                                }
                            })}
                        </Box>

                    </Toolbar>
                </AppBar>
                <nav>
                    <Drawer
                        container={container}
                        variant="temporary"
                        open={mobileOpen}
                        onClose={handleDrawerToggle}
                        ModalProps={{
                            keepMounted: true,
                        }}
                        sx={{
                            display: { xs: 'block', sm: 'none' },
                            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                        }}
                    >
                        <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
                            <List>
                                {navItems.map((item) => (
                                    <ListItem key={item.text} disablePadding>
                                        <ListItemButton sx={{ textAlign: 'center' }}>
                                            {item.popover ? (
                                                <Accordion>
                                                    <AccordionDetails>
                                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                            <BotaoDec />
                                                            <BotaoValores />
                                                            <BotaoCertidoes />
                                                            <BotaoOrientacoes />
                                                        </div>
                                                    </AccordionDetails>
                                                </Accordion>
                                            ) : (
                                                <Link to={item.route} style={{ textDecoration: 'none', color: 'inherit' }}>
                                                    <ListItemText primary={item.text} />
                                                </Link>
                                            )}
                                        </ListItemButton>
                                    </ListItem>
                                ))}
                            </List>
                        </Box>
                    </Drawer>
                </nav>
            </Box>

            <Grid container spacing={4}>
                <Grid item xl={12} lg={12} xs={12}>
                    <Principal />
                </Grid>
                <Grid item xl={12} lg={12} xs={12}>
                <Box sx={{ width: '100%', height: '20vh', display: 'flex', justifyContent: 'space-around', mt: -6, alignItems: 'center', flexWrap: 'wrap' }}>
                    <Button
                        style={{ marginRight: '0', backgroundColor: '#00317F', color: '#fff' }}
                        href="https://www.cnm.org.br/storage/noticias/2023/Links/XXV%20Marcha/programacao-mmm.pdf"
                        target="_blank"
                        endIcon={<ArrowForwardIcon style={{ color: 'orange' }} />}
                    >
                        Programação MMM
                    </Button>
                    <Button
                        style={{ marginLeft: '0px', backgroundColor: '#00317F', color: '#fff' }}
                        href="https://www.cnm.org.br/storage/noticias/2023/Links/XXV%20Marcha/programacao-inovajuntos.pdf"
                        target="_blank"
                        endIcon={<ArrowForwardIcon style={{ color: 'orange' }} />}
                    >
                        Programação InovaJuntos
                    </Button>
                </Box>
                </Grid>
                <Grid item xl={12} lg={12} id="paralela">
                    <Paralela />
                </Grid>
            </Grid>
            <Footer />
        </Grid>
    );
}
